import type { DocumentReference } from 'firebase/firestore'
import { collection, doc, getDoc, orderBy, query, Timestamp, where } from 'firebase/firestore'
import { firestore } from '~/firebaseCore'
import { getIdFromRef } from '~/helpers/getIdFromRef'
import { ROLE } from '~/helpers/roles'

export const collectionNotificationRaports = collection(
  firestore,
  'notificationRaports',
)
export const collectionMenu = collection(
  firestore,
  'menu',
)

export const collectionMenuCategories = collection(
  firestore,
  'menuCategories',
)

export const collectionUsers = collection(
  firestore,
  'users',
)
export const collectionManagers = collection(
  firestore,
  'managers',
)
export const collectionDelivers = collection(
  firestore,
  'delivers',
)
export const collectionOwners = collection(
  firestore,
  'owners',
)
export const collectionModerators = collection(
  firestore,
  'moderators',
)
export const collectionSMS = collection(
  firestore,
  'sms',
)
export const collectionStatisticAccess = collection(
  firestore,
  'statisticAccess',
)
export const collectionCompanies = collection(
  firestore,
  'companies',
)
export const collectionUpdateApplication = collection(
  firestore,
  'updateApplication',
)
export const collectionMenuReturn = collection(
  firestore,
  'menuReturns',
)

export const collectionChangesLogs = collection(
  firestore,
  'changesLogs',
)

export function promoCodeTermsQuery() {
  return getDoc(doc(
    collectionUpdateApplication,
    'promoCodeTerms',
  ))
}

export function recommendationProgramQuery() {
  return getDoc(doc(
    collectionUpdateApplication,
    'recommendationProgram',
  ))
}

export const collectionOrdersStatistic = collection(
  firestore,
  'ordersStatistics',
)

export function getOwner(uid: string) {
  return getDoc(doc(
    collectionOwners,
    uid,
  ))
}

export function getDeliver(uid: string) {
  return getDoc(doc(
    collectionDelivers,
    uid,
  ))
}
export function getManager(uid: string) {
  return getDoc(doc(
    collectionManagers,
    uid,
  ))
}
export function getModerator(uid: string) {
  return getDoc(doc(
    collectionModerators,
    uid,
  ))
}
export function getCustomer(uid: string) {
  return getDoc(doc(
    collectionUsers,
    uid,
  ))
}

export function getLandingCompanies() {
  return query(
    collectionCompanies,
    where(
      'isActive',
      '==',
      true,
    ),
  )
}

export function statisticAccessDoc(companyRef: string) {
  return getDoc(doc(
    collectionStatisticAccess,
    companyRef,
  ),
  )
}

export function deliver(company: DocumentReference) {
  return query(
    collectionDelivers,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'role',
      '==',
      ROLE.DELIVER,
    ),
  )
}

export function getdeliver(company: DocumentReference) {
  return query(
    collectionDelivers,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'role',
      '==',
      ROLE.GET_DELIVER,
    ),
  )
}

export function getBillers(company: DocumentReference) {
  return query(
    collectionDelivers,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'role',
      '==',
      ROLE.BILLER,
    ),
  )
}

export function accountant(company: DocumentReference) {
  return query(
    collectionManagers,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'role',
      '==',
      ROLE.ACCOUNTANT,
    ),
  )
}

export function getActiveDelivers(companyRef: DocumentReference) {
  return query(
    collectionDelivers,
    where(
      'company',
      '==',
      companyRef,
    ),
    where(
      'isActive',
      '==',
      true,
    ),
  )
}

export function manager(company: DocumentReference) {
  return query(
    collectionManagers,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'role',
      '==',
      ROLE.MANAGER,
    ),

  )
}

export function owner(company: DocumentReference) {
  return query(
    collectionOwners,
    where(
      'company',
      '==',
      company,
    ),
  )
}

export function menuByCategoryRef(companyRef: DocumentReference, menuCategoryID: string, isActive: boolean) {
  return query(
    collectionMenu,
    where(
      'companyRef',
      '==',
      companyRef,
    ),
    where(
      'categoryID',
      '==',
      menuCategoryID,
    ),
    where(
      'isActive',
      '==',
      isActive,
    ),
  )
}

export function getMenuByDay(companyRef: DocumentReference, day: string) {
  return query(
    collectionMenu,
    where(
      'companyRef',
      '==',
      companyRef,
    ),
    where(
      'isActive',
      '==',
      true,
    ),
    where(
      'activeDays',
      'array-contains',
      day,
    ),
  )
}

export function menuCategoriesRef(company: DocumentReference) {
  return doc(
    collectionMenuCategories,
    getIdFromRef(company),
  )
}

export function getLockedUsers(reference: DocumentReference) {
  return query(
    collectionUsers,
    where(
      'work.suppliers',
      'array-contains',
      reference,
    ),
    where(
      'ordersAvailable',
      '==',
      false,
    ),
  )
}

export function getUsersBySuppliers(reference: DocumentReference) {
  return query(
    collectionUsers,
    where(
      'work.suppliers',
      'array-contains',
      reference,
    ),
  )
}

export function getNotificationsByRouteDate(routeRef: DocumentReference, dateFrom: Date, dateTo: Date) {
  return query(
    collectionNotificationRaports,
    where(
      'route',
      '==',
      routeRef,
    ),
    where(
      'sendDate',
      '>=',
      Timestamp.fromDate(dateFrom),
    ),
    where(
      'sendDate',
      '<',
      Timestamp.fromDate(dateTo),
    ),
    orderBy('sendDate', 'desc'),
  )
}

export function getCollectionOrdersStatistic(company: DocumentReference, startDate: Timestamp, endDate: Timestamp, city: string) {
  return query(
    collectionOrdersStatistic,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'city',
      '==',
      city,
    ),
    where(
      'date',
      '>=',
      startDate,
    ),
    where(
      'date',
      '<',
      endDate,
    ),
  )
}
export function getSingleOrdersStatistic(company: DocumentReference, city: string, date: Timestamp) {
  return query(
    collectionOrdersStatistic,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'city',
      '==',
      city,
    ),
    where(
      'date',
      '==',
      date,
    ),
  )
}

export function getCollectionChangesReport(
  company: DocumentReference,
  startDate: Timestamp,
  endDate: Timestamp,
) {
  return query(
    collectionChangesLogs,
    where(
      'company',
      '==',
      company,
    ),
    where(
      'date',
      '>=',
      startDate,
    ),
    where(
      'date',
      '<=',
      endDate,
    ),
    orderBy(
      'date',
      'asc',
    ),
  )
}
